import React, { useEffect } from "react";
import { Grid, InputAdornment, Typography } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { useEquipment, useUser } from "@services/servicesGenericsTables";
import {
  MAutocomplete,
  MDatePicker,
  MTextField,
  ResponsiveFormContainer,
} from "@app/components";
import useFilterSamplingProcedure from "@app/hooks/useFilterSamplingProcedure";
import useAuth from "@app/context/AuthContext";
import { formatDateOrNow } from "@app/utils/formatDate";

const Grinding = () => {
  const form = useFormContext();
  const filterSamplingProcedureList = useFilterSamplingProcedure("MOLI");
  const { equipmentList } = useEquipment();
  const { userList } = useUser();
  const { user } = useAuth();

  useEffect(() => {
    if (!form.getValues("processing_analyst_grinding")) {
      form.setValue("processing_analyst_grinding", user);
    }

    if (!form.getValues("processing_date_time_grinding")) {
      form.setValue("processing_date_time_grinding", formatDateOrNow());
    }

    if (!form.getValues("processing_procedure_grinding")) {
      form.setValue(
        "processing_procedure_grinding",
        filterSamplingProcedureList[0] || undefined
      );
    }
  }, []);

  return (
    <>
      <Grid item xs={12} my={2}>
        <Typography variant="tagText">{"Molienda"}</Typography>
      </Grid>
      <ResponsiveFormContainer columns={5} mt={1}>
        <MAutocomplete
          key={JSON.stringify(form.getValues("processing_analyst_grinding"))}
          name="processing_analyst_grinding"
          options={userList}
          label="Seleccione un analista"
          getOptionLabel={(option) => option.username || ""}
          validation={{ required: "El analista es requerido" }}
        />
        <MAutocomplete
          key={JSON.stringify(form.getValues("processing_procedure_grinding"))}
          name="processing_procedure_grinding"
          options={filterSamplingProcedureList}
          label="Procedimiento MLPMA"
          getOptionLabel={(option) => `${option.numop}` || ""}
          validation={{
            required:
              filterSamplingProcedureList.length > 0
                ? "El procedimiento MLPMA es requerido"
                : false,
          }}
        />
        <MAutocomplete
          key={JSON.stringify(form.getValues("processing_equipment_grinding"))}
          name="processing_equipment_grinding"
          options={equipmentList}
          label="Seleccione un Equipo"
          getOptionLabel={(option) =>
            `${option.codigo} - ${option.descripcion}` || ""
          }
          validation={{ required: "El equipo es requerido" }}
          multiple={true}
        />
        <MDatePicker
          name="processing_date_time_grinding"
          pickerType="datetime"
          label="Fecha y hora Inicio"
          validation={{ required: "La fecha y hora de inicio es requerida" }}
        />

        <MTextField
          key={JSON.stringify(form.getValues("sample_quantity_grinding"))}
          name="sample_quantity_grinding"
          placeholder="Cantidad muestra"
          label="Cantidad muestra"
          type="number"
          fullWidth
        />
      </ResponsiveFormContainer>
    </>
  );
};

export default Grinding;
